module.exports = __webpack_public_path__ + "static/media/question-circle.7f9af1e1.svg";